module.exports = __webpack_public_path__ + "img/summary.e44c4f68.png";